export default {
  "content": "<path d=\"M7.5 16L2 10.5 7.5 5l1.062 1.062L4.875 9.75H18v1.5H4.875l3.687 3.688L7.5 16z\" fill=\"currentColor\"/>",
  "attrs": {
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};